import WIDGETS from './widgets';

export default {
	name: 'kind_chat_user_careteam',
	spacing: 2,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.CHAT_USER_CARETEAM, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
